import httpClient from './httpClient'

export default {
  async getAccountQualities() {
    let ret = await httpClient.get('/library')
    return ret
  },
  async updateQualities(data, libraryId) {
    let ret = await httpClient.put(`/library/${libraryId}`, data)
    return ret
  },
}
